// extracted by mini-css-extract-plugin
module.exports = {"introduction":"introduction___3H0i2","TextArea":"TextArea___2YxT3","FInputWordCount":"FInputWordCount___ma3x3","beyond":"beyond___3BopU"};